import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import authActions from '@/redux/auth/actions';
import App from './App';

const mapStateToProps = ({ auth }) => ({ auth });

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      checkToken: authActions.checkToken,
      fetchOrganizations: authActions.fetchOrganizations,
      signOut: authActions.signOut,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(App);
